module.exports = __webpack_public_path__ + "static/media/image_slider_home_03.5a638fcd.jpg";